
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { VProgress } from 'vuetify/labs/VProgress'
import { de } from 'vuetify/locale'

export default createVuetify({
    theme: {
        defaultTheme: 'rwbTheme',        
        themes: {
        rwbTheme: {
            dark: true,
            colors: {
                background: '#151515',
                primary: '#550088',
                'primary-lighten-1': '#651098',
                'primary-lighten-2': '#7520A8',
                'primary-lighten-3': '#8530b8',
                'primary-darken-1': '#450078',
                secondary: '#455f52',
                dark: '#451555',
                'dark-lighten-1': '#552565',
                'dark-lighten-2': '#653575',
                light: '#CCCCDD',
                'light-darken-1': '#BCBCCD',
                'light-darken-2': '#ACACBD',
                'light-darken-3': '#9C9CAD',
                accent: '#82B1FF',
                error: '#c92323',
                info: '#5b8b8b',
                success: '#52a135',
                warning: '#836200',
                white: '#FFFFFF',
                surface: '#252525',
                'surface-lighten-1': '#353535',
                input: '#FAFAFA',
                overlayMask: '#000000',
                'selection': '#CCAAFF',
            },
            variables: {
            }
        }
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
        mdi
        },
    },
    locale: {
        locale: 'de',
        messages: { de },
    },
    components: {
        VProgress,
    }    
})